import { BuildingModel } from 'src/app/shared/models/building.model';
import { DecimalPipe } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ManageBuildingHelperService {
  format = '1.2-2';

  constructor(
    private decPipe: DecimalPipe,
    private _formBuilder: FormBuilder
  ) {}

  public setMoneySavingsData(building: BuildingModel, moneySavingGroup: any) {
    building.moneySaving.energyPrice =
      moneySavingGroup.controls['energyPrice'].value;
    building.moneySaving.groundSaving =
      moneySavingGroup.controls['groundSaving'].value;
    building.moneySaving.groundSavingPerArea =
      moneySavingGroup.controls['groundSavingPerArea'].value;
    building.moneySaving.heatingCost =
      moneySavingGroup.controls['heatingCost'].value;
    building.moneySaving.heatingCostPerArea =
      moneySavingGroup.controls['heatingCostPerArea'].value;
    building.moneySaving.roofSaving =
      moneySavingGroup.controls['roofSaving'].value;
    building.moneySaving.roofSavingPerArea =
      moneySavingGroup.controls['roofSavingPerArea'].value;
    building.moneySaving.sumSaving =
      moneySavingGroup.controls['sumSaving'].value;
    building.moneySaving.sumSavingPerArea =
      moneySavingGroup.controls['sumSavingPerArea'].value;
    building.moneySaving.wallsSaving =
      moneySavingGroup.controls['wallsSaving'].value;
    building.moneySaving.wallsSavingPerArea =
      moneySavingGroup.controls['wallsSavingPerArea'].value;
    building.moneySaving.windowsSaving =
      moneySavingGroup.controls['windowsSaving'].value;
    building.moneySaving.windowsSavingPerArea =
      moneySavingGroup.controls['windowsSavingPerArea'].value;
  }

  public setInvestmentData(
    building: BuildingModel,
    investmentGroup: any,
    pricePerInvestmentGroup: any
  ) {
    building.investment.groundInvestment =
      investmentGroup.controls['groundInvestment'].value;
    building.investment.roofsInvestment =
      investmentGroup.controls['roofsInvestment'].value;
    building.investment.sumInvestment =
      investmentGroup.controls['sumInvestment'].value;
    building.investment.unitPriceForGroundIsolation =
      investmentGroup.controls['unitPriceForGroundIsolation'].value;
    building.investment.unitPriceForRoofsIsolation =
      investmentGroup.controls['unitPriceForRoofsIsolation'].value;
    building.investment.unitPriceForWallIsolation =
      investmentGroup.controls['unitPriceForWallIsolation'].value;
    building.investment.unitPriceForWindowsIsolation =
      investmentGroup.controls['unitPriceForWindowsIsolation'].value;
    building.investment.wallsInvestment =
      investmentGroup.controls['wallsInvestment'].value;
    building.investment.windowsInvestment =
      investmentGroup.controls['windowsInvestment'].value;

    building.pricePerInvestment.costOfSavedKWhAllMeasures =
      pricePerInvestmentGroup.controls['costOfSavedKWhAllMeasures'].value;
    building.pricePerInvestment.costOfSavedKWhFloors =
      pricePerInvestmentGroup.controls['costOfSavedKWhFloors'].value;
    building.pricePerInvestment.costOfSavedKWhRoof =
      pricePerInvestmentGroup.controls['costOfSavedKWhRoof'].value;
    building.pricePerInvestment.costOfSavedKWhWalls =
      pricePerInvestmentGroup.controls['costOfSavedKWhWalls'].value;
    building.pricePerInvestment.costOfSavedKWhWindows =
      pricePerInvestmentGroup.controls['costOfSavedKWhWindows'].value;
  }

  public setGasData(
    building: BuildingModel,
    coGroup: any,
    cO2Group: any,
    dustGroup: any,
    nmvocGroup: any,
    noxGroup: any,
    so2Group: any
  ) {
    building.co.decreaseByGroundIsolation =
      coGroup.controls['decreaseByGroundIsolation'].value;
    building.co.decreaseByRoofsIsolation =
      coGroup.controls['decreaseByRoofsIsolation'].value;
    building.co.decreaseByWallsIsolation =
      coGroup.controls['decreaseByWallsIsolation'].value;
    building.co.decreaseByWindowsIsolation =
      coGroup.controls['decreaseByWindowsIsolation'].value;
    building.co.sumDecrease = coGroup.controls['sumDecrease'].value;
    building.co.transmision = coGroup.controls['transmision'].value;

    building.cO2.decreaseByGroundIsolation =
      cO2Group.controls['decreaseByGroundIsolation'].value;
    building.cO2.decreaseByRoofsIsolation =
      cO2Group.controls['decreaseByRoofsIsolation'].value;
    building.cO2.decreaseByWallsIsolation =
      cO2Group.controls['decreaseByWallsIsolation'].value;
    building.cO2.decreaseByWindowsIsolation =
      cO2Group.controls['decreaseByWindowsIsolation'].value;
    building.cO2.sumDecrease = cO2Group.controls['sumDecrease'].value;
    building.cO2.transmision = cO2Group.controls['transmision'].value;

    building.dust.decreaseByGroundIsolation =
      dustGroup.controls['decreaseByGroundIsolation'].value;
    building.dust.decreaseByRoofsIsolation =
      dustGroup.controls['decreaseByRoofsIsolation'].value;
    building.dust.decreaseByWallsIsolation =
      dustGroup.controls['decreaseByWallsIsolation'].value;
    building.dust.decreaseByWindowsIsolation =
      dustGroup.controls['decreaseByWindowsIsolation'].value;
    building.dust.sumDecrease = dustGroup.controls['sumDecrease'].value;
    building.dust.transmision = dustGroup.controls['transmision'].value;

    building.nmvoc.decreaseByGroundIsolation =
      nmvocGroup.controls['decreaseByGroundIsolation'].value;
    building.nmvoc.decreaseByRoofsIsolation =
      nmvocGroup.controls['decreaseByRoofsIsolation'].value;
    building.nmvoc.decreaseByWallsIsolation =
      nmvocGroup.controls['decreaseByWallsIsolation'].value;
    building.nmvoc.decreaseByWindowsIsolation =
      nmvocGroup.controls['decreaseByWindowsIsolation'].value;
    building.nmvoc.sumDecrease = nmvocGroup.controls['sumDecrease'].value;
    building.nmvoc.transmision = nmvocGroup.controls['transmision'].value;

    building.nox.decreaseByGroundIsolation =
      noxGroup.controls['decreaseByGroundIsolation'].value;
    building.nox.decreaseByRoofsIsolation =
      noxGroup.controls['decreaseByRoofsIsolation'].value;
    building.nox.decreaseByWallsIsolation =
      noxGroup.controls['decreaseByWallsIsolation'].value;
    building.nox.decreaseByWindowsIsolation =
      noxGroup.controls['decreaseByWindowsIsolation'].value;
    building.nox.sumDecrease = noxGroup.controls['sumDecrease'].value;
    building.nox.transmision = noxGroup.controls['transmision'].value;

    building.sO2.decreaseByGroundIsolation =
      so2Group.controls['decreaseByGroundIsolation'].value;
    building.sO2.decreaseByRoofsIsolation =
      so2Group.controls['decreaseByRoofsIsolation'].value;
    building.sO2.decreaseByWallsIsolation =
      so2Group.controls['decreaseByWallsIsolation'].value;
    building.sO2.decreaseByWindowsIsolation =
      so2Group.controls['decreaseByWindowsIsolation'].value;
    building.sO2.sumDecrease = so2Group.controls['sumDecrease'].value;
    building.sO2.transmision = so2Group.controls['transmision'].value;
  }

  public setDetailsData(building: BuildingModel, detailsGroup: any) {
    building.details.accessRampForSsrPeople =
      detailsGroup.controls['accessRampForSsrPeople'].value;
    building.details.addressNumber =
      detailsGroup.controls['addressNumber'].value;
    building.details.addressNumber1 =
      detailsGroup.controls['addressNumber1'].value;
    building.details.addressStreet =
      detailsGroup.controls['addressStreet'].value;
    building.details.addressStreet1 =
      detailsGroup.controls['addressStreet1'].value;
    building.details.hasAntiFireLaddersAndWorks =
      detailsGroup.controls['hasAntiFireLaddersAndWorks'].value;
    building.details.aparmentsExcludedFromCentralHeating =
      detailsGroup.controls['aparmentsExcludedFromCentralHeating'].value;
    building.details.apartmentArea =
      detailsGroup.controls['apartmentArea'].value;
    building.details.apartments = detailsGroup.controls['apartments'].value;
    building.details.apartmentsByFloor =
      detailsGroup.controls['apartmentsByFloor'].value;
    building.details.apartmentsForRent =
      detailsGroup.controls['apartmentsForRent'].value;
    building.details.apartmentsForRentDetails =
      detailsGroup.controls['apartmentsForRentDetails'].value;

    building.details.archiveDate = detailsGroup.controls['archiveDate'].value;
    building.details.archiveDate1 = detailsGroup.controls['archiveDate1'].value;

    building.details.archiveNumber1 =
      detailsGroup.controls['archiveNumber1'].value;

    building.details.buildingManagementType =
      detailsGroup.controls['buildingManagementType'].value;
    building.details.commonSpaceDescription =
      detailsGroup.controls['commonSpaceDescription'].value;
    building.details.constructionBetweenFloors =
      detailsGroup.controls['constructionBetweenFloors'].value;
    building.details.contractNumber =
      detailsGroup.controls['contractNumber'].value;
    building.details.eastBuildingArea =
      detailsGroup.controls['eastBuildingArea'].value;
    building.details.elevatorDescription =
      detailsGroup.controls['elevatorDescription'].value;
    building.details.elevatorMaintenanceCompany =
      detailsGroup.controls['elevatorMaintenanceCompany'].value;

    building.details.elevatorMaintenanceCompanyContact =
      detailsGroup.controls['elevatorMaintenanceCompanyContact'].value;
    building.details.elevatorState =
      detailsGroup.controls['elevatorState'].value;
    building.details.emptyApartments =
      detailsGroup.controls['emptyApartments'].value;
    building.details.entranceDoorState =
      detailsGroup.controls['entranceDoorState'].value;
    building.details.entrances = detailsGroup.controls['entrances'].value;
    building.details.facadeState = detailsGroup.controls['facadeState'].value;
    building.details.floors = detailsGroup.controls['floors'].value;
    building.details.hasAntiFireDeviceAndWorks =
      detailsGroup.controls['hasAntiFireDeviceAndWorks'].value;

    building.details.hasCommonSpace =
      detailsGroup.controls['hasCommonSpace'].value;
    building.details.hasElevator = detailsGroup.controls['hasElevator'].value;

    building.details.hasHydrantAndWorks =
      detailsGroup.controls['hasHydrantAndWorks'].value;
    building.details.hasLightningRod =
      detailsGroup.controls['hasLightningRod'].value;
    building.details.hasSsrPeople = detailsGroup.controls['hasSsrPeople'].value;
    building.details.height = detailsGroup.controls['height'].value;

    building.details.isLandPrivatize =
      detailsGroup.controls['isLandPrivatize'].value;

    building.details.isOkLightningRod =
      detailsGroup.controls['isOkLightningRod'].value;
    building.details.lastYearRenovation =
      detailsGroup.controls['lastYearRenovation'].value;
    building.details.length = detailsGroup.controls['length'].value;
    building.details.managementContact =
      detailsGroup.controls['managementContact'].value;

    building.details.managementName =
      detailsGroup.controls['managementName'].value;
    building.details.municipality = detailsGroup.controls['municipality'].value;
    building.details.municipality1 =
      detailsGroup.controls['municipality1'].value;
    building.details.northBuildingArea =
      detailsGroup.controls['northBuildingArea'].value;
    building.details.notes = detailsGroup.controls['notes'].value;
    building.details.officeSpace = detailsGroup.controls['officeSpace'].value;
    building.details.officeSpaceDescription =
      detailsGroup.controls['officeSpaceDescription'].value;
    building.details.partInPercentage =
      detailsGroup.controls['partInPercentage'].value;
    building.details.region = detailsGroup.controls['region'].value;
    building.details.responsibleDataPerson =
      detailsGroup.controls['responsibleDataPerson'].value;
    building.details.roofState = detailsGroup.controls['roofState'].value;
    building.details.roofType = detailsGroup.controls['roofType'].value;
    building.details.roofCovering = detailsGroup.controls['roofCovering'].value;
    building.details.southBuildingArea =
      detailsGroup.controls['southBuildingArea'].value;
    building.details.ssrPeople = detailsGroup.controls['ssrPeople'].value;
    building.details.wallsType = detailsGroup.controls['wallsType'].value;
    building.details.waysOfHeating =
      detailsGroup.controls['waysOfHeating'].value;
    building.details.westBuildingArea =
      detailsGroup.controls['westBuildingArea'].value;
    building.details.width = detailsGroup.controls['width'].value;
    building.details.windowsState = detailsGroup.controls['windowsState'].value;
    building.details.yearOfBuild = detailsGroup.controls['yearOfBuild'].value;
  }

  public setBasicData(
    building: BuildingModel,
    basicGroup: any,
    energyGroup: any,
    geometryGroup: any
  ) {
    building.latitude = basicGroup.controls['latitude'].value;
    building.longitude = basicGroup.controls['longitude'].value;
    building.street = basicGroup.controls['street'].value;
    building.streetNumber = basicGroup.controls['streetNumber'].value;
    building.construction = basicGroup.controls['construction'].value;
    building.municipalityId = basicGroup.controls['municipalityId'].value;
    building.energy.yearlyRequredEnergy =
      energyGroup.controls['yearlyRequredEnergy'].value;
    building.energy.energyType = energyGroup.controls['energyType'].value;

    building.energy.buildingEnergyClass =
      energyGroup.controls['buildingEnergyClass'].value;

    building.energy.buildingEnergyClassAfterAllMeasures =
      energyGroup.controls['buildingEnergyClassAfterAllMeasures'].value;

    building.energy.yearlyRequredEnergyPerM2 =
      energyGroup.controls['yearlyRequredEnergyPerM2'].value;

    building.energy.yearlyRequredEnergyPerM2AfterAllMeasures =
      energyGroup.controls['yearlyRequredEnergyPerM2AfterAllMeasures'].value;

    building.energy.groundIsolationSaving =
      energyGroup.controls['groundIsolationSaving'].value;
    building.energy.roofsIsolationSaving =
      energyGroup.controls['roofsIsolationSaving'].value;
    building.energy.sumIsolationSaving =
      energyGroup.controls['sumIsolationSaving'].value;
    building.energy.wallsIsolationSaving =
      energyGroup.controls['wallsIsolationSaving'].value;
    building.energy.windowsIsolationSaving =
      energyGroup.controls['windowsIsolationSaving'].value;
    building.energy.yearlyRequredEnergyAfterAllMeasures =
      energyGroup.controls['yearlyRequredEnergyAfterAllMeasures'].value;
    building.energy.yearlyRequredEnergyAfterGroundIsolation =
      energyGroup.controls['yearlyRequredEnergyAfterGroundIsolation'].value;
    building.energy.yearlyRequredEnergyAfterRoofIsolation =
      energyGroup.controls['yearlyRequredEnergyAfterRoofIsolation'].value;
    building.energy.yearlyRequredEnergyAfterWallsIsolation =
      energyGroup.controls['yearlyRequredEnergyAfterWallsIsolation'].value;
    building.energy.yearlyRequredEnergyAfterWindowIsolation =
      energyGroup.controls['yearlyRequredEnergyAfterWindowIsolation'].value;

    building.geometry.area = geometryGroup.controls['area'].value;
    building.geometry.basePerimetar =
      geometryGroup.controls['basePerimetar'].value;
    building.geometry.basement = geometryGroup.controls['basement'].value;
    building.geometry.branchingFactorBasically =
      geometryGroup.controls['branchingFactorBasically'].value;
    building.geometry.facadeArea = geometryGroup.controls['facadeArea'].value;
    building.geometry.floors = geometryGroup.controls['floors'].value;
    building.geometry.formFactor = geometryGroup.controls['formFactor'].value;
    building.geometry.heatedBases = geometryGroup.controls['heatedBases'].value;
    building.geometry.volume = geometryGroup.controls['volume'].value;
    building.geometry.windowArea = geometryGroup.controls['windowArea'].value;
  }

  public setConsumationData(building: BuildingModel, consumationGroup: any) {
    building.consumation.groundIsolationSaving =
      consumationGroup.controls['groundIsolationSaving'].value;
    building.consumation.roofsIsolationSaving =
      consumationGroup.controls['roofsIsolationSaving'].value;
    building.consumation.sumIsolationSaving =
      consumationGroup.controls['sumIsolationSaving'].value;
    building.consumation.wallsIsolationSaving =
      consumationGroup.controls['wallsIsolationSaving'].value;
    building.consumation.windowsIsolationSaving =
      consumationGroup.controls['windowsIsolationSaving'].value;
    building.consumation.yearlyRequredEnergy =
      consumationGroup.controls['yearlyRequredEnergy'].value;
  }

  public setProfitabilityData(
    building: BuildingModel,
    profitabilityGroup: any
  ) {
    building.profitability.returnPeriodForAllMeasures =
      profitabilityGroup.controls['returnPeriodForAllMeasures'].value;
    building.profitability.returnPeriodForGroundIsolation =
      profitabilityGroup.controls['returnPeriodForGroundIsolation'].value;
    building.profitability.returnPeriodForRoofIsolation =
      profitabilityGroup.controls['returnPeriodForRoofIsolation'].value;
    building.profitability.returnPeriodForWallIsolation =
      profitabilityGroup.controls['returnPeriodForWallIsolation'].value;
    building.profitability.returnPeriodForWindowsIsolation =
      profitabilityGroup.controls['returnPeriodForWindowsIsolation'].value;
    building.profitability.yieldRateForAllMeasures =
      profitabilityGroup.controls['yieldRateForAllMeasures'].value;
    building.profitability.yieldRateForGroundIsolation =
      profitabilityGroup.controls['yieldRateForGroundIsolation'].value;
    building.profitability.yieldRateForRoofIsolation =
      profitabilityGroup.controls['yieldRateForRoofIsolation'].value;
    building.profitability.yieldRateForWallIsolation =
      profitabilityGroup.controls['yieldRateForWallIsolation'].value;
    building.profitability.yieldRateForWindowsIsolation =
      profitabilityGroup.controls['yieldRateForWindowsIsolation'].value;
  }

  public initBasicGroup(building: BuildingModel) {
    return this._formBuilder.group({
      construction: [building.construction],
      longitude: [building.longitude],
      latitude: [building.latitude],
      street: [building.street],
      streetNumber: [building.streetNumber],
      municipalityId: [building.municipalityId],
    });
  }

  public initCo2Group(building: BuildingModel) {
    return this._formBuilder.group({
      transmision: [
        this.decPipe.transform(building.cO2.transmision, this.format),
      ],
      decreaseByWallsIsolation: [
        this.decPipe.transform(
          building.cO2.decreaseByWallsIsolation,
          this.format
        ),
      ],
      decreaseByRoofsIsolation: [
        this.decPipe.transform(
          building.cO2.decreaseByRoofsIsolation,
          this.format
        ),
      ],
      decreaseByWindowsIsolation: [
        this.decPipe.transform(
          building.cO2.decreaseByWindowsIsolation,
          this.format
        ),
      ],
      decreaseByGroundIsolation: [
        this.decPipe.transform(
          building.cO2.decreaseByGroundIsolation,
          this.format
        ),
      ],
      sumDecrease: [
        this.decPipe.transform(building.cO2.sumDecrease, this.format),
      ],
    });
  }

  public initEnergyGroup(building: BuildingModel) {
    return this._formBuilder.group({
      yearlyRequredEnergy: [
        this.decPipe.transform(building.energy.yearlyRequredEnergy),
      ],
      yearlyRequredEnergyAfterWallsIsolation: [
        this.decPipe.transform(
          building.energy.yearlyRequredEnergyAfterWallsIsolation,
          this.format
        ),
      ],
      yearlyRequredEnergyAfterRoofIsolation: [
        this.decPipe.transform(
          building.energy.yearlyRequredEnergyAfterRoofIsolation,
          this.format
        ),
      ],
      yearlyRequredEnergyAfterWindowIsolation: [
        this.decPipe.transform(
          building.energy.yearlyRequredEnergyAfterWindowIsolation,
          this.format
        ),
      ],
      yearlyRequredEnergyAfterGroundIsolation: [
        this.decPipe.transform(
          building.energy.yearlyRequredEnergyAfterGroundIsolation,
          this.format
        ),
      ],
      yearlyRequredEnergyAfterAllMeasures: [
        this.decPipe.transform(
          building.energy.yearlyRequredEnergyAfterAllMeasures,
          this.format
        ),
      ],
      wallsIsolationSaving: [
        this.decPipe.transform(
          building.energy.wallsIsolationSaving,
          this.format
        ),
      ],
      roofsIsolationSaving: [
        this.decPipe.transform(
          building.energy.roofsIsolationSaving,
          this.format
        ),
      ],
      windowsIsolationSaving: [
        this.decPipe.transform(
          building.energy.windowsIsolationSaving,
          this.format
        ),
      ],
      groundIsolationSaving: [
        this.decPipe.transform(
          building.energy.groundIsolationSaving,
          this.format
        ),
      ],
      sumIsolationSaving: [
        this.decPipe.transform(building.energy.sumIsolationSaving, this.format),
      ],
      energyType: [
        building.energy.energyType ? building.energy.energyType : '',
      ],

      buildingEnergyClass: [
        building.energy.buildingEnergyClass
          ? building.energy.buildingEnergyClass
          : '',
      ],
      buildingEnergyClassAfterAllMeasures: [
        building.energy.buildingEnergyClassAfterAllMeasures
          ? building.energy.buildingEnergyClassAfterAllMeasures
          : '',
      ],
      yearlyRequredEnergyPerM2: [
        this.decPipe.transform(
          building.energy.yearlyRequredEnergyPerM2,
          this.format
        ),
      ],
      yearlyRequredEnergyPerM2AfterAllMeasures: [
        this.decPipe.transform(
          building.energy.yearlyRequredEnergyPerM2AfterAllMeasures,
          this.format
        ),
      ],
    });
  }

  public initGeometryGroup(building: BuildingModel) {
    return this._formBuilder.group({
      area: [this.decPipe.transform(building.geometry.area, this.format)],
      basePerimetar: [
        this.decPipe.transform(building.geometry.basePerimetar, this.format),
      ],
      floors: [building.geometry.floors ? building.geometry.floors : ''],
      facadeArea: [
        this.decPipe.transform(building.geometry.facadeArea, this.format),
      ],
      windowArea: [
        this.decPipe.transform(building.geometry.windowArea, this.format),
      ],
      basement: [building.geometry.basement ? building.geometry.basement : ''],
      heatedBases: [building.geometry.heatedBases],
      volume: [this.decPipe.transform(building.geometry.volume, this.format)],
      formFactor: [
        this.decPipe.transform(building.geometry.formFactor, this.format),
      ],
      branchingFactorBasically: [
        this.decPipe.transform(
          building.geometry.branchingFactorBasically,
          this.format
        ),
      ],
    });
  }

  public initInvestmentGroup(building: BuildingModel) {
    return this._formBuilder.group({
      wallsInvestment: [
        this.decPipe.transform(
          building.investment.wallsInvestment,
          this.format
        ),
      ],
      roofsInvestment: [
        this.decPipe.transform(
          building.investment.roofsInvestment,
          this.format
        ),
      ],
      windowsInvestment: [
        this.decPipe.transform(
          building.investment.windowsInvestment,
          this.format
        ),
      ],
      groundInvestment: [
        this.decPipe.transform(
          building.investment.groundInvestment,
          this.format
        ),
      ],
      sumInvestment: [
        this.decPipe.transform(building.investment.sumInvestment, this.format),
      ],
      unitPriceForWallIsolation: [
        this.decPipe.transform(
          building.investment.unitPriceForWallIsolation,
          this.format
        ),
      ],
      unitPriceForRoofsIsolation: [
        this.decPipe.transform(
          building.investment.unitPriceForRoofsIsolation,
          this.format
        ),
      ],
      unitPriceForWindowsIsolation: [
        this.decPipe.transform(
          building.investment.unitPriceForWindowsIsolation,
          this.format
        ),
      ],
      unitPriceForGroundIsolation: [
        this.decPipe.transform(
          building.investment.unitPriceForGroundIsolation,
          this.format
        ),
      ],
    });
  }

  public initMoneySavingsGroup(building: BuildingModel) {
    return this._formBuilder.group({
      heatingCost: [
        this.decPipe.transform(building.moneySaving.heatingCost, this.format),
      ],
      heatingCostPerArea: [
        this.decPipe.transform(
          building.moneySaving.heatingCostPerArea,
          this.format
        ),
      ],
      wallsSaving: [
        this.decPipe.transform(building.moneySaving.wallsSaving, this.format),
      ],
      wallsSavingPerArea: [
        this.decPipe.transform(
          building.moneySaving.wallsSavingPerArea,
          this.format
        ),
      ],
      roofSaving: [
        this.decPipe.transform(building.moneySaving.roofSaving, this.format),
      ],
      roofSavingPerArea: [
        this.decPipe.transform(
          building.moneySaving.roofSavingPerArea,
          this.format
        ),
      ],
      windowsSaving: [
        this.decPipe.transform(building.moneySaving.windowsSaving, this.format),
      ],
      windowsSavingPerArea: [
        this.decPipe.transform(
          building.moneySaving.windowsSavingPerArea,
          this.format
        ),
      ],
      groundSaving: [
        this.decPipe.transform(building.moneySaving.groundSaving, this.format),
      ],
      groundSavingPerArea: [
        this.decPipe.transform(
          building.moneySaving.groundSavingPerArea,
          this.format
        ),
      ],
      sumSaving: [
        this.decPipe.transform(building.moneySaving.sumSaving, this.format),
      ],
      sumSavingPerArea: [
        this.decPipe.transform(
          building.moneySaving.sumSavingPerArea,
          this.format
        ),
      ],
      energyPrice: [
        this.decPipe.transform(building.moneySaving.energyPrice, this.format),
      ],
    });
  }

  public initCoGroup(building: BuildingModel) {
    return this._formBuilder.group({
      transmision: [
        this.decPipe.transform(building.co.transmision, this.format),
      ],
      decreaseByWallsIsolation: [
        this.decPipe.transform(
          building.co.decreaseByWallsIsolation,
          this.format
        ),
      ],
      decreaseByRoofsIsolation: [
        this.decPipe.transform(
          building.co.decreaseByRoofsIsolation,
          this.format
        ),
      ],
      decreaseByWindowsIsolation: [
        this.decPipe.transform(
          building.co.decreaseByWindowsIsolation,
          this.format
        ),
      ],
      decreaseByGroundIsolation: [
        this.decPipe.transform(
          building.co.decreaseByGroundIsolation,
          this.format
        ),
      ],
      sumDecrease: [
        this.decPipe.transform(building.co.sumDecrease, this.format),
      ],
    });
  }

  public initConsumationGroup(building: BuildingModel) {
    return this._formBuilder.group({
      yearlyRequredEnergy: [
        this.decPipe.transform(
          building.consumation.yearlyRequredEnergy,
          this.format
        ),
      ],
      wallsIsolationSaving: [
        this.decPipe.transform(
          building.consumation.wallsIsolationSaving,
          this.format
        ),
      ],
      roofsIsolationSaving: [
        this.decPipe.transform(
          building.consumation.roofsIsolationSaving,
          this.format
        ),
      ],
      windowsIsolationSaving: [
        this.decPipe.transform(
          building.consumation.windowsIsolationSaving,
          this.format
        ),
      ],
      groundIsolationSaving: [
        this.decPipe.transform(
          building.consumation.groundIsolationSaving,
          this.format
        ),
      ],
      sumIsolationSaving: [
        this.decPipe.transform(
          building.consumation.sumIsolationSaving,
          this.format
        ),
      ],
    });
  }

  public initDustGroup(building: BuildingModel) {
    return this._formBuilder.group({
      transmision: [
        this.decPipe.transform(building.dust.transmision, this.format),
      ],
      decreaseByWallsIsolation: [
        this.decPipe.transform(
          building.dust.decreaseByWallsIsolation,
          this.format
        ),
      ],
      decreaseByRoofsIsolation: [
        this.decPipe.transform(
          building.dust.decreaseByRoofsIsolation,
          this.format
        ),
      ],
      decreaseByWindowsIsolation: [
        this.decPipe.transform(
          building.dust.decreaseByWindowsIsolation,
          this.format
        ),
      ],
      decreaseByGroundIsolation: [
        this.decPipe.transform(
          building.dust.decreaseByGroundIsolation,
          this.format
        ),
      ],
      sumDecrease: [
        this.decPipe.transform(building.dust.sumDecrease, this.format),
      ],
    });
  }

  public initNmvocGroup(building: BuildingModel) {
    return this._formBuilder.group({
      transmision: [
        this.decPipe.transform(building.nmvoc.transmision, this.format),
      ],
      decreaseByWallsIsolation: [
        this.decPipe.transform(building.nmvoc.decreaseByWallsIsolation),
      ],
      decreaseByRoofsIsolation: [
        this.decPipe.transform(
          building.nmvoc.decreaseByRoofsIsolation,
          this.format
        ),
      ],
      decreaseByWindowsIsolation: [
        this.decPipe.transform(
          building.nmvoc.decreaseByWindowsIsolation,
          this.format
        ),
      ],
      decreaseByGroundIsolation: [
        this.decPipe.transform(
          building.nmvoc.decreaseByGroundIsolation,
          this.format
        ),
      ],
      sumDecrease: [
        this.decPipe.transform(building.nmvoc.sumDecrease, this.format),
      ],
    });
  }

  public initNoxGroup(building: BuildingModel) {
    return this._formBuilder.group({
      transmision: [
        this.decPipe.transform(building.nox.transmision, this.format),
      ],
      decreaseByWallsIsolation: [
        this.decPipe.transform(
          building.nox.decreaseByWallsIsolation,
          this.format
        ),
      ],
      decreaseByRoofsIsolation: [
        this.decPipe.transform(
          building.nox.decreaseByRoofsIsolation,
          this.format
        ),
      ],
      decreaseByWindowsIsolation: [
        this.decPipe.transform(
          building.nox.decreaseByWindowsIsolation,
          this.format
        ),
      ],
      decreaseByGroundIsolation: [
        this.decPipe.transform(
          building.nox.decreaseByGroundIsolation,
          this.format
        ),
      ],
      sumDecrease: [
        this.decPipe.transform(building.nox.sumDecrease, this.format),
      ],
    });
  }

  public initPricePerInvestmentGroup(building: BuildingModel) {
    return this._formBuilder.group({
      costOfSavedKWhWalls: [
        this.decPipe.transform(
          building.pricePerInvestment.costOfSavedKWhWalls,
          this.format
        ),
      ],
      costOfSavedKWhRoof: [
        this.decPipe.transform(
          building.pricePerInvestment.costOfSavedKWhRoof,
          this.format
        ),
      ],
      costOfSavedKWhWindows: [
        this.decPipe.transform(
          building.pricePerInvestment.costOfSavedKWhWindows,
          this.format
        ),
      ],
      costOfSavedKWhFloors: [
        this.decPipe.transform(
          building.pricePerInvestment.costOfSavedKWhFloors,
          this.format
        ),
      ],
      costOfSavedKWhAllMeasures: [
        this.decPipe.transform(
          building.pricePerInvestment.costOfSavedKWhAllMeasures,
          this.format
        ),
      ],
    });
  }

  public initProfitabilityGroup(building: BuildingModel) {
    return this._formBuilder.group({
      returnPeriodForWallIsolation: [
        this.decPipe.transform(
          building.profitability.returnPeriodForWallIsolation,
          this.format
        ),
      ],
      yieldRateForWallIsolation: [
        this.decPipe.transform(
          building.profitability.yieldRateForWallIsolation,
          this.format
        ),
      ],
      returnPeriodForRoofIsolation: [
        this.decPipe.transform(
          building.profitability.returnPeriodForRoofIsolation,
          this.format
        ),
      ],
      yieldRateForRoofIsolation: [
        this.decPipe.transform(
          building.profitability.yieldRateForRoofIsolation,
          this.format
        ),
      ],
      returnPeriodForWindowsIsolation: [
        this.decPipe.transform(
          building.profitability.returnPeriodForWindowsIsolation,
          this.format
        ),
      ],
      yieldRateForWindowsIsolation: [
        this.decPipe.transform(
          building.profitability.yieldRateForWindowsIsolation,
          this.format
        ),
      ],
      returnPeriodForGroundIsolation: [
        this.decPipe.transform(
          building.profitability.returnPeriodForGroundIsolation,
          this.format
        ),
      ],
      yieldRateForGroundIsolation: [
        this.decPipe.transform(
          building.profitability.yieldRateForGroundIsolation,
          this.format
        ),
      ],
      returnPeriodForAllMeasures: [
        this.decPipe.transform(
          building.profitability.returnPeriodForAllMeasures,
          this.format
        ),
      ],
      yieldRateForAllMeasures: [
        this.decPipe.transform(
          building.profitability.yieldRateForAllMeasures,
          this.format
        ),
      ],
    });
  }

  public initSo2Group(building: BuildingModel) {
    return this._formBuilder.group({
      transmision: [
        this.decPipe.transform(building.sO2.transmision, this.format),
      ],
      decreaseByWallsIsolation: [
        this.decPipe.transform(
          building.sO2.decreaseByWallsIsolation,
          this.format
        ),
      ],
      decreaseByRoofsIsolation: [
        this.decPipe.transform(
          building.sO2.decreaseByRoofsIsolation,
          this.format
        ),
      ],
      decreaseByWindowsIsolation: [
        this.decPipe.transform(
          building.sO2.decreaseByWindowsIsolation,
          this.format
        ),
      ],
      decreaseByGroundIsolation: [
        this.decPipe.transform(
          building.sO2.decreaseByGroundIsolation,
          this.format
        ),
      ],
      sumDecrease: [
        this.decPipe.transform(building.sO2.sumDecrease, this.format),
      ],
    });
  }

  public initDetailsGroup(building: BuildingModel) {
    return this._formBuilder.group({
      archiveDate: [
        building.details.archiveDate ? building.details.archiveDate : '',
      ],
      municipality: [
        building.details.municipality ? building.details.municipality : '',
      ],
      addressStreet: [
        building.details.addressStreet ? building.details.addressStreet : '',
      ],
      addressNumber: [
        building.details.addressNumber ? building.details.addressNumber : '',
      ],
      floors: [building.details.floors ? building.details.floors : 0],
      apartments: [
        building.details.apartments ? building.details.apartments : 0,
      ],
      yearOfBuild: [
        building.details.yearOfBuild ? building.details.yearOfBuild : '',
      ],
      lastYearRenovation: [
        building.details.lastYearRenovation
          ? building.details.lastYearRenovation
          : '',
      ],
      partInPercentage: [
        building.details.partInPercentage
          ? building.details.partInPercentage
          : '',
      ],
      apartmentsForRent: [
        building.details.apartmentsForRent
          ? building.details.apartmentsForRent
          : '',
      ],
      apartmentsForRentDetails: [
        building.details.apartmentsForRentDetails
          ? building.details.apartmentsForRentDetails
          : '',
      ],
      buildingManagementType: [
        building.details.buildingManagementType
          ? building.details.buildingManagementType
          : '',
      ],
      managementContact: [
        building.details.managementContact
          ? building.details.managementContact
          : '',
      ],
      archiveNumber1: [
        building.details.archiveNumber1 ? building.details.archiveNumber1 : '',
      ],
      archiveDate1: [
        building.details.archiveDate1 ? building.details.archiveDate1 : '',
      ],
      managementName: [
        building.details.managementName ? building.details.managementName : '',
      ],
      municipality1: [
        building.details.municipality1 ? building.details.municipality1 : '',
      ],
      region: [building.details.region ? building.details.region : ''],
      addressStreet1: [
        building.details.addressStreet1 ? building.details.addressStreet1 : '',
      ],
      addressNumber1: [
        building.details.addressNumber1 ? building.details.addressNumber1 : '',
      ],
      contractNumber: [
        building.details.contractNumber ? building.details.contractNumber : '',
      ],
      height: [this.decPipe.transform(building.details.height, this.format)],
      length: [this.decPipe.transform(building.details.length, this.format)],
      width: [this.decPipe.transform(building.details.width, this.format)],
      entrances: [building.details.entrances ? building.details.entrances : 0],
      apartmentsByFloor: [
        building.details.apartmentsByFloor
          ? building.details.apartmentsByFloor
          : '',
      ],
      apartmentArea: [
        building.details.apartmentArea ? building.details.apartmentArea : '',
      ],
      emptyApartments: [
        building.details.emptyApartments
          ? building.details.emptyApartments
          : '',
      ],
      officeSpace: [
        building.details.officeSpace ? building.details.officeSpace : '',
      ],
      officeSpaceDescription: [
        building.details.officeSpaceDescription
          ? building.details.officeSpaceDescription
          : '',
      ],
      hasElevator: [
        building.details.hasElevator ? building.details.hasElevator : '',
      ],
      elevatorDescription: [
        building.details.elevatorDescription
          ? building.details.elevatorDescription
          : '',
      ],
      elevatorState: [
        building.details.elevatorState ? building.details.elevatorState : '',
      ],
      elevatorMaintenanceCompany: [
        building.details.elevatorMaintenanceCompany
          ? building.details.elevatorMaintenanceCompany
          : '',
      ],
      elevatorMaintenanceCompanyContact: [
        building.details.elevatorMaintenanceCompanyContact
          ? building.details.elevatorMaintenanceCompanyContact
          : '',
      ],
      hasCommonSpace: [
        building.details.hasCommonSpace ? building.details.hasCommonSpace : '',
      ],
      commonSpaceDescription: [
        building.details.commonSpaceDescription
          ? building.details.commonSpaceDescription
          : '',
      ],
      isLandPrivatize: [
        building.details.isLandPrivatize ? building.details.isLandPrivatize : 0,
      ],
      wallsType: [building.details.wallsType ? building.details.wallsType : ''],
      constructionBetweenFloors: [
        building.details.constructionBetweenFloors
          ? building.details.constructionBetweenFloors
          : '',
      ],
      roofType: [building.details.roofType ? building.details.roofType : ''],
      roofCovering: [building.details.roofCovering ? building.details.roofCovering : ''],
      northBuildingArea: [
        building.details.northBuildingArea
          ? building.details.northBuildingArea
          : 0,
      ],
      southBuildingArea: [
        building.details.southBuildingArea
          ? building.details.southBuildingArea
          : 0,
      ],
      eastBuildingArea: [
        building.details.eastBuildingArea
          ? building.details.eastBuildingArea
          : 0,
      ],
      westBuildingArea: [
        building.details.westBuildingArea
          ? building.details.westBuildingArea
          : 0,
      ],
      roofState: [building.details.roofState ? building.details.roofState : ''],
      facadeState: [
        building.details.facadeState ? building.details.facadeState : '',
      ],
      windowsState: [
        building.details.windowsState ? building.details.windowsState : '',
      ],
      entranceDoorState: [
        building.details.entranceDoorState
          ? building.details.entranceDoorState
          : '',
      ],
      waysOfHeating: [
        building.details.waysOfHeating ? building.details.waysOfHeating : '',
      ],
      aparmentsExcludedFromCentralHeating: [
        building.details.aparmentsExcludedFromCentralHeating
          ? building.details.aparmentsExcludedFromCentralHeating
          : '',
      ],

      hasAntiFireLaddersAndWorks: [
        building.details.hasAntiFireLaddersAndWorks
          ? building.details.hasAntiFireLaddersAndWorks
          : '',
      ],
      hasHydrantAndWorks: [
        building.details.hasHydrantAndWorks
          ? building.details.hasHydrantAndWorks
          : '',
      ],

      hasAntiFireDeviceAndWorks: [
        building.details.hasAntiFireDeviceAndWorks
          ? building.details.hasAntiFireDeviceAndWorks
          : '',
      ],

      hasSsrPeople: [
        building.details.hasSsrPeople ? building.details.hasSsrPeople : '',
      ],
      ssrPeople: [building.details.ssrPeople ? building.details.ssrPeople : 0],
      accessRampForSsrPeople: [
        building.details.accessRampForSsrPeople
          ? building.details.accessRampForSsrPeople
          : '',
      ],
      hasLightningRod: [
        building.details.hasLightningRod
          ? building.details.hasLightningRod
          : '',
      ],
      isOkLightningRod: [
        building.details.isOkLightningRod
          ? building.details.isOkLightningRod
          : '',
      ],
      notes: [building.details.notes ? building.details.notes : ''],
      responsibleDataPerson: [
        building.details.responsibleDataPerson
          ? building.details.responsibleDataPerson
          : '',
      ],
    });
  }
}
